import styled from "styled-components";

export const StyledDescription = styled.h3`
  margin: 0;
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 1.22rem;
  line-height: 1.6;
  color: rgba(191, 219, 254, 1);
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 32px;

  @media (max-width: 480px) {
    font-size: 1.1rem;
    line-height: 1.4;
    margin-bottom: 22px;
  }
`;
